import {
    CHANGE_DETAILS_OPEN_MODAL,
    CHANGE_DETAILS_CLOSE_MODAL,
} from 'Redux/actionTypes';

export const changeDetailsOpenModal = (item) => ({
    type: CHANGE_DETAILS_OPEN_MODAL,
    payload: item
})

export const changeDetailsCloseModal = () => ({
    type: CHANGE_DETAILS_CLOSE_MODAL
})